import { endOfWeek as endOfWeekBase } from 'date-fns'

export function endOfWeek(locale: Locale) {
  return (date: Date) => endOfWeekBase(date, { locale, weekStartsOn: 1 })
}
